<template>
  <div id="charts2" style="width: 100%;height: 300px;background:white;">
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'TempCharts2',
  data () {
    return {
      x: 0
    }
  },
  methods: {
    initCharts () {
      var x = this.x
      var myChart = echarts.init(document.getElementById('charts2'))

      var data = [['12:06:05', 40], ['12:06:06', 43], ['12:06:07', 45], ['12:06:08', 47], ['12:06:09', 50], ['12:06:10', 54], ['12:06:11', 60], ['12:06:12', 66], ['12:06:13', 70], ['12:06:14', 66], ['12:06:15', 65], ['12:06:16', 64], ['12:06:17', 60], ['12:06:18', 58], ['12:06:19', 57], ['12:06:20', 55], ['12:06:21', 54], ['12:06:22', 50], ['12:06:23', 49], ['12:06:24', 48], ['12:06:25', 47], ['12:06:26', 44], ['12:06:27', 50], ['12:06:28', 56], ['12:06:29', 60], ['12:06:30', 68], ['12:07:01', 70], ['12:07:02', 66], ['12:07:03', 65], ['12:07:04', 63], ['12:07:05', 60], ['12:07:06', 58], ['12:07:07', 56], ['12:07:08', 54], ['12:07:09', 53], ['12:07:10', 50], ['12:07:11', 47], ['12:07:12', 46], ['12:07:13', 48], ['12:07:14', 50], ['12:07:15', 54], ['12:07:16', 60], ['12:07:17', 66], ['12:07:18', 64], ['12:07:19', 60], ['12:07:20', 58], ['12:07:21', 57], ['12:07:22', 55], ['12:07:23', 53], ['12:07:24', 50]]
      var dateList = data.map(function (item) {
        return item[0]
      })
      var valueList = data.map(function (item) {
        return item[1]
      })
      var option = {

        visualMap: {
          show: false,
          type: 'continuous',
          seriesIndex: 0,
          min: 30,
          max: 120
        },
        title: {
          left: 'center',
          text: '温度监测'
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          data: dateList
        },
        yAxis: {},

        series: {
          type: 'line',
          showSymbol: false,
          data: valueList
        }
      }
      myChart.setOption(option)

      setInterval(function () {
        x = parseInt(Math.random() * (5 - (-5) + 1) + (-5), 10)
        data.shift()
        data.push(['12:07:24', 40 + x])
        dateList = data.map(function (item) {
          return item[0]
        })
        valueList = data.map(function (item) {
          return item[1]
        })
        option = {

          visualMap: {
            show: false,
            type: 'continuous',
            seriesIndex: 0,
            min: 30,
            max: 120
          },
          title: {
            left: 'center',
            text: '温度监测'
          },
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            data: dateList
          },
          yAxis: {},

          series: {
            type: 'line',
            showSymbol: false,
            data: valueList
          }
        }
        myChart.setOption(option)
      }, 2000)
    }
  },

  mounted () {
    this.initCharts()
  }
}

</script>

<style scoped>

</style>
